<template>
  <SidebarShell :model="model" />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'

import { type ArchivedFile } from '@/shared/graphql/legacy/generated'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'
import { formatTimestamp } from '@/shared/utils/datetime'
import { useDevice } from '@/shared/composables/useDevice'
import { usePlatformStore } from '@/shared/stores/platform'
import SidebarShell from './sidebar/SidebarShell.vue'
import type { SidebarModel, SidebarRow } from './sidebar/types'

const props = defineProps<{
  selectedItem?: ArchivedFile
  total?: number | null
}>()

const device = useDevice()
const platformStore = usePlatformStore()

if (device.isTabletHorizontal.value) {
  platformStore.setSidebarCollapse(true)
}

watch(
  () => props.selectedItem,
  () => {
    if (
      document.body.style.pointerEvents === 'none' ||
      device.isDesktop.value
    ) {
      return
    }
    platformStore.setSidebarCollapse(!props.selectedItem)
  }
)

const model = computed<SidebarModel | null>(() => {
  const file = props.selectedItem
  if (file) {
    const rows: SidebarRow[] = [
      { kind: 'text', label: 'Located in', value: 'Archive' },
      {
        kind: 'text',
        label: 'Archived at',
        value: formatTimestamp(file.archivedAt) ?? '',
      },
      { kind: 'text', label: 'Size', value: file.size },
      { kind: 'text', label: 'Type', value: file.friendlyType },
    ]

    return {
      title: file.fileName,
      share: null,
      thumbnail: { type: fileTypeToThumbnail(file.type), src: file.imageUrl },
      rows,
    }
  }

  if (props.total === undefined || props.total === null) return null

  return {
    title: 'Archived registrations',
    share: null,
    thumbnail: { type: 'folder' },
    rows: [
      {
        kind: 'text',
        label: 'Number of archived registrations',
        value: String(props.total),
      },
    ],
  }
})
</script>
